import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import { Amplify } from 'aws-amplify';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import theme from './context/theme';

import { LayoutProvider } from './context/LayoutContext';

import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';

import App from './App';

const _theme = createTheme(theme);

// -----------------------
// AWS Amplify configuration
// -----------------------
Amplify.configure({
	Auth: {
		Cognito: {
			identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID,
			userPoolId: import.meta.env.VITE_USER_POOL_ID,
			userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
			allowGuestAccess: false,
		},
	},
});

// -----------------------
// Lazy‑loaded route components
// -----------------------
const ListContainer = React.lazy(() => import('./modules/pages/withdrawals/ListContainer'));
const FormContainer = React.lazy(() => import('./modules/pages/withdrawals/FormContainer'));

// -----------------------
// Reusable wrapper to inject providers around each route element
// -----------------------
function AppWrapper({ children }: { children: React.ReactNode }) {
	return (
		<LayoutProvider>
			<ThemeProvider theme={_theme}>
				{/* @ts-expect-error */}
				<App>{children}</App>
			</ThemeProvider>
		</LayoutProvider>
	);
}

// -----------------------
// React‑Router v7 route definitions
// -----------------------
const router = createBrowserRouter([
	{
		path: '/',
		element: (
			<AppWrapper>
				<ListContainer />
			</AppWrapper>
		),
	},
	{
		path: '/withdrawal/list',
		element: (
			<AppWrapper>
				<ListContainer />
			</AppWrapper>
		),
	},
	{
		path: '/withdrawal/new',
		element: (
			<AppWrapper>
				<FormContainer />
			</AppWrapper>
		),
	},
	{
		path: '/withdrawal/show',
		element: (
			<AppWrapper>
				<FormContainer />
			</AppWrapper>
		),
	},
	{
		path: '*',
		element: <Navigate to="/" replace />,
	},
]);

// -----------------------
// Render the application (React 18+)
// -----------------------
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<Suspense fallback={<div>Loading…</div>}>
		<RouterProvider router={router} />
	</Suspense>,
);
